;(function($, window, document){
    window.ProductHero = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'scrollToConfiguration');

            this.addEvents();

        },
        addEvents: function() {
            this.$('.hero-footer .cta').on('click', this.scrollToConfiguration);
        },
        scrollToConfiguration: function(e){
            var view = this;

            $('html, body').animate(
                {
                    scrollTop: view.$el.parent().find('.configurator').offset().top - 70 // Scroll to this location.
                }, {
                    // Set the duration long enough to allow time
                    // to lazy load the elements.
                    duration: 700,

                    // At each animation step, check whether the target has moved.
                    step: function( now, fx ) {

                        // Where is the target now located on the page?
                        // i.e. its location will change as images etc. are lazy loaded
                        var newOffset = view.$el.parent().find('.configurator').offset().top - 70

                        // If where we were originally planning to scroll to is not
                        // the same as the new offset (newOffset) then change where
                        // the animation is scrolling to (fx.end).
                        if(fx.end !== newOffset)
                            fx.end = newOffset;
                    }
                }
            );
        }
    });
}(jQuery, window, document));